export default __webpack_public_path__ + "static/media/manhigot-mission.7ad28b4d.png";